import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetLoginAttemptsRequest } from '@cash-web/shared-util-protos/squareup/cash/janus/api/GetLoginAttempts.pb'
import { GetLoginAttemptsResponse } from '@cash-web/shared-util-protos/squareup/cash/janus/api/GetLoginAttempts.pb'

export const getLoginAttempts = (request: GetLoginAttemptsRequest, options?: CashRequestOptions) =>
  post<GetLoginAttemptsRequest, GetLoginAttemptsResponse>('/2.0/cash/get-login-attempts', request, {
    ...options,
    rejectOnError: true,
  })
